import * as types from '../actions/actionTypes';

const initialState = {
  iframeIntegrationRequest: {},
  iframeIntegrationResponse: {},
};

export default function(state = initialState, action) {
  let newState = {...state};
  switch(action.type) {
    case types.SET_IFRAME_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        iframeIntegrationRequest: {...action.payload.iframeIntegrationRequest}
      });
    case types.SET_IFRAME_INTEGRATION_RESPONSE:
      return Object.assign({}, state, {
        iframeIntegrationResponse: {...action.payload.iframeIntegrationResponse}
      });
  }
  return newState;
}
